import React from 'react'
import { WebView } from 'react-native-webview'
import { Dimensions } from 'react-native'
import { isWeb } from '../../utils/isWeb'

const width = Dimensions.get('window').width
const height = Dimensions.get('window').height

const uri = 'https://www.brioincorporadora.com.br/politica-de-privacidade-cookies-standalone'

export const TermsOfUse: React.FC = () => {
  if (isWeb()) {
    return <iframe style={{ width: '100%', height: '100%', flex: 1 }} src={uri} />
  }
  return (
    <WebView
      source={{ uri }}
      style={{ width, height, flex: 1 }}
    />
  )
}
